export enum IPageStatus {
    STAGE_1 = 'STAGE_1', // CES 预热+ VR/AR挑战赛
    STAGE_2 = 'STAGE_2', // CES预热+ 挑战赛获胜者揭晓+最后一次更新用户图片
    STAGE_3 = 'STAGE_3', // 增加现场活动照片模块
    STAGE_4 = 'STAGE_4', // 增加获奖信息模块
}
